import actionCreatorFactory from 'typescript-fsa';
import { WeeklyComment } from '../../services/betting';

const actionCreator = actionCreatorFactory();

export const RADIOEINS_LOAD_WEEKLY_COMMENT = 'RADIOEINS_LOAD_WEEKLY_COMMENT';
export const radioEinsLoadWeeklyComment = actionCreator(RADIOEINS_LOAD_WEEKLY_COMMENT);

export const RADIOEINS_SET_WEEKLY_COMMENT = 'RADIOEINS_SET_WEEKLY_COMMENT';
export const radioEinsSetWeeklyComment = actionCreator<WeeklyComment>(RADIOEINS_SET_WEEKLY_COMMENT);